// routes.js
import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Route,
} from "react-router-dom";
import Splash from "./screens/Splash";
import VideoRecordScreen from "./screens/VideoRecordScreen";
import ViewVideoScreen from "./screens/ViewVideoScreen";

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/" element={<Splash />} />
      <Route path="/record" element={<VideoRecordScreen />} />
      <Route path="/view" element={<ViewVideoScreen />} />
      <Route path="*" element={<Navigate to="/" />} />
    </>
  )
);

export default router;
